import React from 'react'
import { Dropdown } from 'react-bootstrap'
import SwalCustom from '../../../alert/swal-custom'
import useExportPimEmployeeExcel from '../../../hooks/use-export-pim-employee-excel'

// PIM "Export Excel Full" — Meegle 14443031. The backend now generates and streams the .xlsx
// directly; this component only triggers the download and reports the outcome. Column layout,
// data formatting, and the ผู้บังคับบัญชา/Supervisor resolution all moved server-side (see
// hrms-backend src/controllers/excel/exportEmployeeExcel.js + handle.js).
export default function ExportExcelFull1({ type_name, parame, createEmpsExcelLog2 }) {
  const { exportPimEmployeeExcel, isExporting } = useExportPimEmployeeExcel()

  const handleExport = async () => {
    if (isExporting) return

    const success = await exportPimEmployeeExcel(parame)
    if (!success) return

    await createEmpsExcelLog2(1)
    SwalCustom({
      title: 'Success!',
      text: 'Exported',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500
    })
  }

  return (
    <Dropdown.Item onClick={handleExport} disabled={isExporting}>
      <span
        style={{
          fontSize: '14px'
        }}
      >
        {isExporting ? 'Exporting...' : type_name}
      </span>
    </Dropdown.Item>
  )
}
